import type { Environment } from './environment.model';

/** Build preprod (`yarn build:preprod`) — télémétrie active vers la stack interne. */
export const environment: Environment = {
  production: false,
  telemetry: {
    enabled: true,
    serviceName: 'zazu-web',
    serviceVersion: '1.0.0',
    environment: 'preprod',
    collectorBaseUrl: '/collect',
    tracesSampleRatio: 1,
    metricsExportIntervalMillis: 30000,
  },
};
